function productOverviewResetStyles() {
    var elements = document.querySelectorAll('.product-overview__group *')
    if (elements !== null) {
        Array.from(elements).forEach(function (el) {
            el.removeAttribute('style')
        })
    }
}

export { productOverviewResetStyles }
